var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getCardList, { formatCardList } from '../utils/getCardList';
import { requestCardData, fetchData } from '../utils/api';
import getParams from '../utils/getParams';
import { CardStyleType, COMMODITY_INFO_CONFIG } from '../type/feConfig';
import { getUTMParams } from '../utils/utm';
import { getMtProgramRiskParams } from '../utils/riskParams';
/**
 * 数据加载策略基类
 * 包含通用的请求逻辑和缓存管理
 */
export class BaseCardDataStrategy {
    constructor(cityId, props, texReportData, ctx) {
        this.cityId = cityId;
        this.props = props;
        this.texReportData = texReportData;
        this.ctx = ctx;
        this.cache = [];
        this.isLastPage = false;
        this.totalPageCount = 0;
        this.requestedPageCount = 0;
        this.currentPageNo = 0;
    }
    /**
     * 执行单次数据请求
     */
    fetchPage() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = yield getParams(this.requestedPageCount, this.cityId, this.props, (_b = (_a = this.ctx) === null || _a === void 0 ? void 0 : _a._runtimeInfo) === null || _b === void 0 ? void 0 : _b.commonParams);
                const utmParams = getUTMParams(this.ctx);
                const riskParams = yield getMtProgramRiskParams((_d = (_c = this.ctx) === null || _c === void 0 ? void 0 : _c._runtimeInfo) === null || _d === void 0 ? void 0 : _d.queryParams);
                // 根据 commodityInfoConfig 选择不同的请求方式
                if (this.props.commodityInfoConfig === COMMODITY_INFO_CONFIG.SUPPLY_ID) {
                    // 供给ID方式 - 使用新接口
                    const res = yield fetchData({
                        path: '/landing/page/query/simpleShelf/data',
                        method: 'POST',
                        params: Object.assign(Object.assign({}, params), { utmParams: utmParams, riskParams: riskParams !== null && riskParams !== void 0 ? riskParams : {} })
                    });
                    if (!(res === null || res === void 0 ? void 0 : res.data)) {
                        (_f = (_e = this.ctx._raptorReport) === null || _e === void 0 ? void 0 : _e.monitorReportBizFailed) === null || _f === void 0 ? void 0 : _f.call(_e, {
                            city_id: String(this.cityId)
                        });
                        throw new Error('请求数据失败');
                    }
                    if (!Array.isArray(res.data.list) || res.data.list.length === 0) {
                        // 货架空搜
                        (_h = (_g = this.ctx._raptorReport) === null || _g === void 0 ? void 0 : _g.monitorReportShelfEmpty) === null || _h === void 0 ? void 0 : _h.call(_g, {
                            city_id: String(this.cityId)
                        });
                        return null;
                    }
                    else {
                        // 货架正常
                        (_k = (_j = this.ctx._raptorReport) === null || _j === void 0 ? void 0 : _j.monitorReportShelfNormal) === null || _k === void 0 ? void 0 : _k.call(_j);
                        (_m = (_l = this.ctx._raptorReport) === null || _l === void 0 ? void 0 : _l.monitorReportBizSuccess) === null || _m === void 0 ? void 0 : _m.call(_l);
                    }
                    this.totalPageCount = res.data.totalPage;
                    this.requestedPageCount += 1;
                    if (res.data.totalPage && this.requestedPageCount >= res.data.totalPage) {
                        this.isLastPage = true;
                    }
                    else {
                        this.isLastPage = false;
                    }
                    return formatCardList(res.data.list, this.props, this.texReportData);
                }
                else {
                    // Excel导入和输入框录入方式 - 使用原有接口
                    const res = yield requestCardData(this.props, params);
                    (_p = (_o = this.ctx._raptorReport) === null || _o === void 0 ? void 0 : _o.monitorReportNetworkSuccess) === null || _p === void 0 ? void 0 : _p.call(_o);
                    if (!res) {
                        (_r = (_q = this.ctx._raptorReport) === null || _q === void 0 ? void 0 : _q.monitorReportBizFailed) === null || _r === void 0 ? void 0 : _r.call(_q, {
                            city_id: String(this.cityId)
                        });
                        throw new Error('请求数据失败');
                    }
                    if (!Array.isArray(res.productInfoList) || res.productInfoList.length === 0) {
                        // 货架空搜
                        (_t = (_s = this.ctx._raptorReport) === null || _s === void 0 ? void 0 : _s.monitorReportShelfEmpty) === null || _t === void 0 ? void 0 : _t.call(_s, {
                            city_id: String(this.cityId)
                        });
                    }
                    else {
                        // 货架正常
                        (_v = (_u = this.ctx._raptorReport) === null || _u === void 0 ? void 0 : _u.monitorReportShelfNormal) === null || _v === void 0 ? void 0 : _v.call(_u);
                        (_x = (_w = this.ctx._raptorReport) === null || _w === void 0 ? void 0 : _w.monitorReportBizSuccess) === null || _x === void 0 ? void 0 : _x.call(_w);
                    }
                    this.totalPageCount = res.totalPageCount;
                    this.requestedPageCount += 1;
                    if (res.totalPageCount && this.requestedPageCount >= res.totalPageCount) {
                        this.isLastPage = true;
                    }
                    else {
                        this.isLastPage = false;
                    }
                    return getCardList(res, this.props, this.texReportData);
                }
            }
            catch (error) {
                this.isLastPage = true;
                (_z = (_y = this.ctx._raptorReport) === null || _y === void 0 ? void 0 : _y.monitorReportNetworkFailed) === null || _z === void 0 ? void 0 : _z.call(_y);
                this.ctx._raptorReport.reportLog('静态货架请求失败报错', '静态货架请求失败', {
                    level: 'warn',
                    category: 'ajaxError',
                    tags: {
                        texId: this.ctx._runtimeInfo.pageId
                    }
                });
                return null;
            }
        });
    }
    reset() {
        this.cache = [];
        this.isLastPage = false;
        this.totalPageCount = 0;
        this.requestedPageCount = 0;
        this.currentPageNo = 0;
    }
    getDisplayList() {
        return this.cache;
    }
    hasMore() {
        return !this.isLastPage;
    }
    setCityId(cityId) {
        this.cityId = cityId;
    }
}
/**
 * 单列样式数据加载策略
 * 逐页加载，每次加载一页
 */
export class SingleColumnStrategy extends BaseCardDataStrategy {
    loadFirstPage() {
        return __awaiter(this, void 0, void 0, function* () {
            const newCards = yield this.fetchPage();
            if (newCards) {
                this.cache = newCards;
            }
        });
    }
    loadMore() {
        return __awaiter(this, void 0, void 0, function* () {
            const newCards = yield this.fetchPage();
            if (newCards) {
                this.cache = [...this.cache, ...newCards];
            }
        });
    }
}
/**
 * 三列样式数据加载策略
 * 首页需要加载足够的行数，加载更多时按页加载
 * 每次加载更多展示 3 个卡片（一行），如果缓存不足则继续请求
 */
export class ThreeColumnStrategy extends BaseCardDataStrategy {
    constructor(cityId, props, texReportData, ctx) {
        super(cityId, props, texReportData, ctx);
        this.displayCount = 0;
        this.loadRowsNum = 0; // 追踪加载更多的次数
        // 计算首页需要展示的数量：行数 * 3列
        this.firstPageDisplayCount = props.firstPageRows && props.cardStyleType === CardStyleType.ThreeColumn ? props.firstPageRows * 3 : 6;
        // 初始化显示数量为首页数量
        this.displayCount = this.firstPageDisplayCount;
        this.loadRowsNum = props.firstPageRows || 2;
    }
    reset() {
        super.reset();
        this.displayCount = this.firstPageDisplayCount;
        this.loadRowsNum = this.props.firstPageRows || 2;
    }
    getDisplayList() {
        return this.cache.slice(0, this.displayCount);
    }
    hasMore() {
        // 只要缓存中有未显示的卡片，就显示加载更多
        return !this.isLastPage || this.displayCount < this.cache.length;
    }
    loadFirstPage() {
        return __awaiter(this, void 0, void 0, function* () {
            // 持续请求直到有足够数据或到达最后一页
            while (this.cache.length < this.firstPageDisplayCount && !this.isLastPage) {
                const newCards = yield this.fetchPage();
                if (!newCards || newCards.length === 0) {
                    this.isLastPage = true;
                    break;
                }
                this.cache = [...this.cache, ...newCards];
            }
            // 首页只展示计算好的行数
            this.displayCount = Math.min(this.firstPageDisplayCount, this.cache.length);
        });
    }
    loadMore() {
        return __awaiter(this, void 0, void 0, function* () {
            // 三列样式每次加载更多展示 3 个卡片（一行）
            const rowSize = 3;
            // 计算需要展示到的位置
            const nextDisplayCount = this.displayCount + rowSize;
            // 如果缓存不足，请求更多数据，直到有足够的或到达最后一页
            while (this.cache.length < nextDisplayCount && !this.isLastPage) {
                const newCards = yield this.fetchPage();
                if (!newCards || newCards.length === 0) {
                    break;
                }
                this.cache = [...this.cache, ...newCards];
            }
            // 更新显示数量：只展示本次新增的 3 个卡片（或剩余的全部卡片）
            this.displayCount = Math.min(nextDisplayCount, this.cache.length);
            // 追踪加载更多的次数
            this.loadRowsNum += 1;
        });
    }
}
/**
 * 数据加载策略工厂
 */
export class CardDataStrategyFactory {
    createStrategy(styleType, cityId, props, texReportData, ctx) {
        switch (styleType) {
            case CardStyleType.ThreeColumn:
                return new ThreeColumnStrategy(cityId, props, texReportData, ctx);
            case CardStyleType.Normal:
            default:
                return new SingleColumnStrategy(cityId, props, texReportData, ctx);
        }
    }
}
